import React from 'react'
import url from 'front-end-core/core/url'
import { UTILS } from 'constants/controllers'
import cx from 'classnames'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const Header = ({ view }) => {
  const aol = useSelector(selectAolName)

  return (
    <div className='account-navigation persist'>
      <ul>
        <li role='presentation' className={cx({ active: view === 'icons' })}>
          <a href={url(UTILS, { aol, view: 'icons' })}>Icons</a>
        </li>
        <li role='presentation' className={cx({ active: view === 'crypto' })}>
          <a href={url(UTILS, { aol, view: 'crypto' })}>Cryptography</a>
        </li>
      </ul>
    </div>
  )
}

export default Header
